module.exports = "/images/view.svg?0d4ca58253c77b06fbf779f6f5ef52c6";